var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex h-12 sm:h-16 rounded-full font-semibold text-center leading-none",class:[
    _vm.active
      ? 'bg-gray-200 hover:bg-gray-300 text-gray-700'
      : 'bg-transparent mr-2 sm:mr-7 text-gray-100'
  ],on:{"click":function($event){_vm.active && _vm.$emit('update', !_vm.value)}}},[(_vm.value == true || _vm.active)?_c('button',{staticClass:"px-6 rounded-full",class:[
      _vm.active ? (_vm.value == true ? 'bg-teal-500 text-white -mr-2' : '-mr-2') : ''
    ],attrs:{"tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.buttons[0] || '')}}):_vm._e(),(_vm.value == false || _vm.active)?_c('button',{staticClass:"px-6 rounded-full",class:[
      _vm.active
        ? _vm.value == false
          ? 'bg-teal-500 text-white -ml-2'
          : '-ml-2'
        : 'mr-0 sm:mr-1'
    ],attrs:{"tabindex":"-1"},domProps:{"innerHTML":_vm._s(_vm.buttons[1] || '')}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }